/* eslint-disable camelcase */

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { HvInput } from "@hitachivantara/uikit-react-core";
import { useFormikContext } from "formik";

import { parseStatus as ps, parseStatusMessage as psm } from "lib/utils/forms";
import { IncidentType } from "lib/api";

import useStyles from "./styles";

const IconUrlInput: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation("addEditIncidentType");
  const [internalValue, setInternalValue] = useState("");

  const {
    values: { appearance: { icon_type, icon } = {} } = {},
    errors,
    touched,
    status: { serverSideErrors } = {},
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<Partial<IncidentType>>();

  useEffect(() => {
    if (icon_type !== "url") setInternalValue("");
    else setInternalValue(icon || "");
  }, [icon_type, icon]);

  const parseStatus = useCallback(
    (field: string) => ps(field, serverSideErrors, errors, touched),
    [errors, serverSideErrors, touched]
  );

  const parseStatusMessage = useCallback(
    (field: string) => {
      return psm(field, serverSideErrors, errors, touched);
    },
    [errors, serverSideErrors, touched]
  );

  const onChange = useCallback(
    (event, value) => {
      setFieldValue("appearance.icon", value);
    },
    [setFieldValue]
  );

  const onInternalChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => setInternalValue(value);

  const onBlur = useCallback(
    (event) => {
      setFieldTouched("appearance.icon", true, false);

      const value = event?.target.value;
      onChange(event, value === "" ? null : value);
    },
    [setFieldTouched, onChange]
  );

  const disabled = useMemo(() => icon_type !== "url", [icon_type]);

  return (
    <div className={clsx(classes.root, classes.urlInputContainer)}>
      <HvInput
        id="url"
        name="url"
        className={classes.urlInput}
        aria-labelledby="urlIconRadio-label"
        placeholder={t("mapMarker.iconType.options.urlIcon.placeholder")}
        disabled={disabled}
        status={!disabled ? parseStatus("appearance.icon") : "valid"}
        statusMessage={!disabled ? parseStatusMessage("appearance.icon") : ""}
        value={internalValue}
        onBlur={onBlur}
        onEnter={onChange}
        onChange={onInternalChange}
      />
    </div>
  );
};

export default IconUrlInput;
